<template>
	<div class="home_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
		</div>
		<div class="backgroud_bg">
			<img src="../images/index/red_bg.png" alt="" style="width: 100%;">
		</div>
		<div class="bengin_act">
			<div class="empty_box"></div>
			<div class="body_box">
				<div class="honour_left">
					<div class="backgroud_bg" v-if="type == 1">
						<img src="../images/index/honour-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
						<img src="../images/index/honour-3.png" v-else alt="" style="width: 100%;">
					</div>
					<div class="backgroud_bg" v-if="type == 2">
						<img src="../images/index/jt-honour-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
						<img src="../images/index/jt-honour-3.png" v-else alt="" style="width: 100%;">
					</div>
					<div class="honour_content" @click="goDiploma(type)" v-if="type == 1">
						<img src="../images/index/medal/1111.png" v-if="userlevel >= level" alt="" style="width: 100%;">
						<img src="../images/index/medal/222.png" v-else-if="userlevel < level" alt="" style="width: 100%;">
					</div>
					<div class="honour_content" @click="goDiploma(type)" v-else-if="type == 2">
						<img src="../images/index/medal/4444.png" v-if="userlevel >= level" alt="" style="width: 100%;">
						<img src="../images/index/medal/3333.png" v-else-if="userlevel < level" alt="" style="width: 100%;">
					</div>
				</div>
				<div class="honour_right">
					<div class="honour_header">
						<div class="backgroud_bg">
							<img src="../images/index/12.png" alt="" style="width: 100%;">
						</div>
						<div class="honour_content" v-if="type == 1">
							<img src="../images/index/grz-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
							<img src="../images/index/grz-3.png" v-else alt="" style="width: 100%;">
						</div>
						<div class="honour_content" v-else-if="type == 2">
							<img src="../images/index/jtz-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
							<img src="../images/index/jtz-3.png" v-else alt="" style="width: 100%;">
						</div>
					</div>
					<div class="honour_footer" @click="goAddress(type)">
						<img src="../images/index/zs.png" v-if="type == 1" alt="" style="width: 100%;" class="breathe1">
						<img src="../images/index/haojiao.png" v-else alt="" style="width: 100%;" class="breathe1">
					</div>
				</div>
			</div>
			<div class="footer_box">
				<div class="username">{{nickname}}</div>
				<div class="honour_num" v-if="type == 1">{{personal}}</div>
				<div class="honour_num" v-else>{{collective}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"

	export default {
		name: "InfoResult",
		components: {},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				type:1,
				userlevel:0,
				level:12,
				personal:'',
				collective:'',
				nickname:'',
			};
		},
		created() {
			this.nickname = localStorage.getItem('login_usernickname');
			this.userlevel = localStorage.getItem('login_userlevel');
			this.$parent.footer('infoResult',false);
			if (this.$router.history.current.query.type) {
				this.type = parseInt(this.$router.history.current.query.type);
			}
			if(this.userlevel >= this.level){
				this.personal = localStorage.getItem('login_personal2');
				this.collective = localStorage.getItem('login_collective2');
			}else{
				this.personal = localStorage.getItem('login_personal3');
				this.collective = localStorage.getItem('login_collective3');
			}
		},
		watch: {
		},
		mounted() {
			
		},
		methods: {
			goDiploma(obj){
				this.$router.push('/infoDiploma?type='+obj);
			},
			goAddress(obj){
				this.$router.push('/infoAddress'+obj);
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg{
	    position: fixed;
	    top: 0;
	    z-index: 10;
		background-image:none;
		
		.back_left {
			background: url(../../views/images/back_b.png) no-repeat center center;
		}
		.big_tit{
			color: #ffffff;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
		}
	}
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.home_wrap {
		
	}
	.bengin_act {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
		
		.body_box {
		    position: relative;
		    z-index: 9;
		    display: flex;
		    justify-content: center;
			top: 2rem;
			
			.honour_left {
			    position: relative;
			    height: 60vh;
			    z-index: 9;
			    width: 5rem;
				
				.honour_content {
				    position: relative;
				    z-index: 99;
				    width: 60%;
				    left: 20%;
				    top: 1.4rem;
				}
			}
			.honour_right {
			    position: relative;
			    height: 60vh;
			    z-index: 9;
			    width: 3rem;
				
				.honour_header{
					
					.honour_content {
					    position: relative;
						z-index: 99;
						width: 24%;
						left: 38%;
						top: 2rem;
					}
				}
				.honour_footer {
				    position: relative;
				    z-index: 9;
				    width: 70%;
				    left: 10%;
				    top: 4rem;
				}
				.breathe1{
					animation: breathe 1.5s infinite;
				}
			}
		}
		.footer_box {
		    position: relative;
		    width: 70%;
		    left: 30%;
		    top: 2rem;
		    height: 1rem;
		    line-height: 1rem;
		    font-size: 0.6rem;
		    color: #fff;
			text-decoration: underline;
			
			.username {
			    text-align: center;
			    left: -1rem;
			    position: relative;
			}
		}
	}
	@keyframes breathe {
		0%, 100% {
		  transform: scale(1);
		}
		50% {
		  transform: scale(0.9); /* 使div放大 */
		}
	}
</style>
